import { Controller } from "@hotwired/stimulus"


import {stimulus} from "../init"

// Show/hide table columns and remember the choice per event in localStorage.
// Cells opt in with data-col="<key>". Visibility is applied through one <style> element,
// so rows added later (Turbo Streams) follow the same rules with no extra work.
export default class ColumnVisibility extends Controller {
  static targets = ["style", "toggle"]
  static values = { storageKey: String, defaults: Object }

  connect() {
    this.state = { ...this.defaultsValue, ...this.readStored() }
    this.syncToggles()
    this.apply()
  }

  toggle(event) {
    this.state[event.target.dataset.column] = event.target.checked
    this.persist()
    this.apply()
  }

  reset() {
    this.state = { ...this.defaultsValue }
    try { localStorage.removeItem(this.storageKeyValue) } catch (_) {}
    this.syncToggles()
    this.apply()
  }

  syncToggles() {
    this.toggleTargets.forEach((box) => {
      box.checked = this.state[box.dataset.column] !== false
    })
  }

  apply() {
    this.styleTarget.textContent = Object.entries(this.state)
      .filter(([, visible]) => visible === false)
      .map(([key]) => `[data-col="${key}"]{display:none}`)
      .join("\n")
  }

  readStored() {
    try { return JSON.parse(localStorage.getItem(this.storageKeyValue)) || {} } catch (_) { return {} }
  }

  persist() {
    try { localStorage.setItem(this.storageKeyValue, JSON.stringify(this.state)) } catch (_) {}
  }
}

stimulus.register('column-visibilty', ColumnVisibility)
